import { Action } from '../types/types';
import { SET_DOP_INFO } from '../actions/dop';
import { DopSlideInfo } from '../../utils/dop-reconcile';

export interface DopDeckInfo {
	slides: DopSlideInfo[];
}

export interface DopState {
	// keyed by mediaId; string | number matches the repo's numeric-ID-map
	// precedent (masks.ts) since fkId/mediaId can arrive as a string.
	info: Record<string | number, DopDeckInfo>;
}

export const initialDopState: DopState = {
	info: {},
};

const actions: Map<any, Function> = new Map([
	[
		SET_DOP_INFO,
		(state: DopState, action: Action) => ({
			...state,
			info: {
				...state.info,
				[action.payload.mediaId]: { slides: action.payload.slides },
			},
		}),
	],
]);

export const DopReducer = (
	state: DopState = initialDopState,
	action: Action = { type: '', payload: {} },
) => actions.get(action.type)?.(state, action) ?? state;
